import PropTypes from "prop-types";
import { Doughnut } from "react-chartjs-2";
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

function MarketplaceDonutChart({ values }) {
  const data = {
    labels: ["New Listings", "free", "Premium"],
    datasets: [
      {
        data: values,
        borderWidth: 0,
        hoverOffset: 2,
        backgroundColor: ["#8ea2ff", "#49bdd1", "#a862de"],
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "73%",
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div className="sd-donut-chart">
      <Doughnut data={data} options={options} />
    </div>
  );
}

MarketplaceDonutChart.propTypes = {
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
};

export default MarketplaceDonutChart;
